import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class DashboardService extends BaseService {
    constructor() {
        super(apiroutes.DASHBOARD);
    }

    async getDashboardStats(companyId) {
        return await super.customCall('GET', '', null, { companyId }, null);
    }
}

export default new DashboardService();
